<div class="loading-shell">
    <div class="loading-content">
        <ng-content></ng-content>
    </div>

    @if (loading) {
        <div class="loading-overlay" aria-live="polite" aria-busy="true" aria-label="Loading content">
            <div class="loader"></div>
        </div>
    }
</div>